import { addFetch, removeFetch, ITipoIdentificacion, IContacto, ITramite, IMetadatoAsociado, ICategoriaMetadato, DataTableRequest, DataTablesResponse, IRadicadoSalida, IClasificacionPQRS, ITipoPersona, INivelEducativo, IProfesion, ITipoSolicitante, IRadicadoEntrada } from "../ioip/sdk/base";
import { IPqrWebCreationContactData } from "../classes/contact-page";
import { IAppContext } from "../classes/app-context";
import { IRespuestaCreacionRadicadoEntrada } from "../classes/respuesta-creacion-radicado-entrada";
import { IRespuestaAclaracion } from "../classes/respuesta-aclaracion";
import { IRadicadoEntradaExtended } from "../classes/radicado-entrada-extended";
import { IPreguntaSecreta } from "../classes/pregunta-secreta";
import { ISignInResponse } from "../classes/sign-in-response";
import { ISignInRequest } from "../classes/sign-in-request";
import { IAntencionPreferencial } from "../classes/atencion-preferencial";
import { IDiscapacidad } from "../classes/discapacidad";
import { IGenero } from "../classes/genero";
import { IGrupoEtnico } from "../classes/grupo-etnico";
import { IAnswerEntidadAdscrita } from "../classes/entidades-adscritas/answer-entidad-adscrita";
import { IRespuestaEncuestaSatisfaccion } from "../classes/satisfaction-survey/respuesta-encuesta";
import { IPreguntaEncuestaSatisfaccion } from "../classes/satisfaction-survey/pregunta-encuesta";
import { Sede } from "../classes/shared";
import { ISuscriptionParameter } from "../classes/iparametro";
import { ICloserEntidadAdscrita } from "../classes/entidades-adscritas/closer-entidad-adscrita";
import { ICreateChunkResponse } from "ioip-base/lib/common";
import { ICity, ICountry, IDepartment } from "@ioip/archivox/lib";

export class PqrWebService {

  private getProcesoxUrlWithDomain(): string {
    return `${Sede.Shared.ProcesoxUrl}`;
  }

  private get _serviceUrl(): string {
    return `${(window as any).serviceUrl}/tramitex-web-client/api/${(window as any).domain}`;
  }

  private getRequestInit(post: boolean = false, reCaptcha: string = ''): RequestInit {
    const request = {
      method: post ? 'POST' : 'GET',
      headers: {
        'Content-Type': 'application/json',
        'G-Captcha': reCaptcha
      },
    };
    const token = window.sessionStorage.getItem('ioip.pqr-web.session.token');
    if (token !== undefined && token !== null) {
      request.headers[ 'Authorization' ] = 'Bearer ' + window.sessionStorage.getItem('ioip.pqr-web.session.token');
    }
    return request;
  }

  private async aadGet(url: string): Promise<any> {
    try {
      addFetch();
      const response: Response = await fetch(url, this.getRequestInit());
      const result = response.headers.get("content-type") ? await response.json() : null;
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  private async aadGetBlob(url: string, mimeType: string, fileName: string): Promise<void> {
    try {
      addFetch();
      const response: Response = await fetch(url, this.getRequestInit());
      const result = response.headers.get("content-type") ? await response.blob() : null;
      removeFetch();
      if (response.ok) {
        var file = new Blob([result], { type: 'application/pdf' });
        let blobUrl = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      }
      else {
        alert('El radicado seleccionado no tiene documentos adjuntos');
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }


  private async aadGetText(url: string): Promise<string> {
    try {
      addFetch();
      const response: Response = await fetch(url, this.getRequestInit());
      const result = await response.text();
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  private async aadBlob(url: string): Promise<Blob> {
    try {
      addFetch();
      const request = { ...this.getRequestInit() }
      const response: Response = await fetch(url, request);
      removeFetch();

      if (!response.ok) {
        const text = await response.text();
        console.log(text);
        throw Error(text);
      }

      const result = await response.blob();
      return result;
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  protected async aadPostFormData<T>(apiUrl: string, data: FormData): Promise<T> {
    addFetch();
    return new Promise<any>(async (resolve, reject) => {
      try {
        const request = { ...this.getRequestInit(true), body: data };
        delete request.headers[ 'Content-Type' ]
        const response: Response = await fetch(apiUrl, request);
        removeFetch();
        if (response.ok) {
          if (response.status === 204) {
            resolve(null);
          }
          else {
            resolve(response.json());
          }
        } else {
          const err = await response.json();
          reject(err);
        }
      } catch (ex) {
        removeFetch();
        reject({
          ExceptionMessage: `Error de comunicación con el servidor. ${(ex as any).message}`
        });
      }
    });
  }

  public async aadPost(url: string, data: any, reCaptcha?: string): Promise<any> {
    try {
      addFetch();
      const request = { ...this.getRequestInit(true, reCaptcha), body: JSON.stringify(data ? data : {}) }
      const response: Response = await fetch(url, request);

      removeFetch();
      if (!response.ok) {
        const text = await response.json();
        console.log(text);
        throw text;
      }

      const result = await response.json();
      return result;

    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  private async aadPostGetText(url: string, data: any): Promise<string> {
    try {
      addFetch();
      const request = { ...this.getRequestInit(true), body: JSON.stringify(data ? data : {}) }
      const response: Response = await fetch(url, request);
      const result = await response.text();
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  protected async aadDelete(url: string): Promise<void> {
    try {
      addFetch();
      const response: Response = await fetch(url, {
        ...this.getRequestInit(),
        method: 'DELETE'
      });
      const result = await response.json();
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  public async getContextAsync(): Promise<IAppContext> {
    try {
      addFetch();
      const response: Response = await fetch(`${this._serviceUrl}/context`, this.getRequestInit());
      const result = await response.json();
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  public async getTramiteMetadataAsosiationAsync(idTramite: number): Promise<IMetadatoAsociado[]> {
    try {
      addFetch();
      const response: Response = await fetch(`${this._serviceUrl}/tramites/${idTramite}/metadata`, this.getRequestInit());
      const result = await response.json();
      removeFetch();
      if (response.ok) {
        return result;
      }
      else {
        throw result;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  ////#region Parametros


  ////#endregion Parametros

  public async createContactAsync(contacto: IContacto, reCaptcha: string): Promise<IPqrWebCreationContactData> {
    return this.aadPost(`${this._serviceUrl}/contactos`, contacto, reCaptcha);
  }

  public async updateContactAsync(contacto: IContacto, reCaptcha: string): Promise<IPqrWebCreationContactData> {
    return await this.aadPost(`${this._serviceUrl}/contactos/update`, contacto, reCaptcha);
  }

  public async getContactEntitiesAsync(): Promise<IContacto> {
    return await this.aadGet(`${this._serviceUrl}/get-contact-entities`);
  }
  public async resendAccountVerificationUrlAsync(idContacto: number): Promise<void> {
    return this.aadPost(`${this._serviceUrl}/ResendAccountVerificationUrl`, idContacto);
  }

  public async sigInAsync(data: ISignInRequest): Promise<ISignInResponse> {
    return this.aadPost(`${this._serviceUrl}/authenticate`, data);
  }

  // public async createRadicadoEntradaAsync(radicado: IRadicadoEntradaExtended): Promise<IRespuestaCreacionRadicadoEntrada> {
  //   return this.aadPost(`${this._serviceUrl}/CreateRadicado`, radicado);
  // }

  public async uploadRadicadoEntradaFilesAsync(pqr: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/UploadRadicadoEntradaFiles`, pqr);
  }

  public async completeInformationRequestAsync(data: IRespuestaAclaracion): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/GetPqrById(${data.IdRadicadoEntrada})/InformationRequestByIdRadicadoSalida(${data.IdRadicadoSalida})/Complete`, data);
  }

  public async downloadRadicadoSalida(idRadicadoSalida: number): Promise<void> {
    this._aadDownload(`${this._serviceUrl}/GetRadicadoSalidaById(${idRadicadoSalida})/Download`, 'application/zip', 'OFICIO_SALIDA.pdf');
  }

  public async downloadRadicadoSalidaAsAnonymous(idRadicadoSalida: number): Promise<void> {
    this._aadDownload(`${this._serviceUrl}/GetRadicadoSalidaById(${idRadicadoSalida})/DownloadAsAnonymous`, 'application/zip', 'OFICIO_SALIDA.pdf');
  }

  public async verifyAttachmentsRadicadoSalidaAsync(idRadicadoSalida: number): Promise<boolean> {
    return this.aadGet(`${this._serviceUrl}/GetRadicadoSalidaById(${idRadicadoSalida})/VerifyAttactments`);
  }

  public async downloadAttactmentsRadicadoSalida(idRadicadoSalida: number): Promise<void> {
    this._aadDownload(`${this._serviceUrl}/GetRadicadoSalidaById(${idRadicadoSalida})/DownloadAttachments`, 'application/zip', 'anexos_respuesta.zip');
  }

  public async downloadAttactmentsRadicadoSalidaAsAnonymous(idRadicadoSalida: number): Promise<void> {
    this._aadDownload(`${this._serviceUrl}/GetRadicadoSalidaById(${idRadicadoSalida})/DownloadAttachmentsAsAnonymous`, 'application/zip', 'anexos_respuesta.zip');
  }

  public async getDocumentAsAnonymousAsync(idDocumentoExpediente: number, nombreArchivo: string): Promise<void> {
    this._aadDownload(`${this._serviceUrl}/GetDocument/${idDocumentoExpediente}/DownloadAsAnonymous`, 'application/pdf', nombreArchivo);
  }

  public async getDocumentSedeAsAnonymousAsync(idDocumentoExpediente: number, nombreArchivo: string): Promise<void> {
    this.aadGetBlob(`${this._serviceUrl}/GetDocument/${idDocumentoExpediente}/DownloadAsAnonymous`, 'application/pdf', nombreArchivo);
  }  

  public async gerAclaracionesPendientesRadicadoEntradaAsync(idRadicadoEntrada: number): Promise<IRadicadoSalida[]> {
    return this.aadGet(`${this._serviceUrl}/radicado-salida/getAclaracionPendienteRadicadoEntradaAnonymous/${idRadicadoEntrada}`);
  }

  public async decryptsAsync(frase: string): Promise<any> {
    return this.aadPost(`${this._serviceUrl}/decrypt`, frase);
  }





  // Tramites








  public async getAllCountriesAsync(): Promise<ICountry[]> {
    return this.aadGet(`${this._serviceUrl}/paises`);
  }

  public async getAllDepartmentsAsync(): Promise<IDepartment[]> {
    return this.aadGet(`${this._serviceUrl}/departamentos`);
  }

  public async getAllCitiesAsync(): Promise<ICity[]> {
    return this.aadGet(`${this._serviceUrl}/ciudades`);
  }

  public async readExternalMetadataAsync(applicationName: string, className: string): Promise<any[]> {
    return this.aadGet(`${this._serviceUrl}/aplicaciones/${applicationName}/extensions/${className}/read`);
  }

  public async executeAsync(applicationName: string, className: string, data: { [ key: string ]: any }): Promise<any> {
    return this.aadPost(`${this._serviceUrl}/aplicaciones/${applicationName}/extensions/${className}/execute`, data);
  }

  public async getMetadataCategoryByNameAsync(name: string): Promise<ICategoriaMetadato> {
    return this.aadGet(`${this._serviceUrl}/categoria-metadatos/${name}`);
  }

  public async getOptionsByIdMetadatoAsync(id: number): Promise<any[]> {
    return this.aadGet(`${this._serviceUrl}/metadatos/${id}/options`);
  }

  public async getAllIdentificationTypesAsync(): Promise<ITipoIdentificacion[]> {
    return this.aadGet(`${this._serviceUrl}/tipos-identificacion`);
  }

  public async getIdentificationTypesByIdPersonaAsync(idTipoPersona: number): Promise<ITipoIdentificacion[]> {
    return this.aadGet(`${this._serviceUrl}/tipos-identificacion-persona/${idTipoPersona}/`);
  }

  public async getAllQuestionsAsync(): Promise<IPreguntaSecreta[]> {
    return this.aadGet(`${this._serviceUrl}/preguntas-secretas`);
  }

  public async getAllPreferentialCareTypesAsync(): Promise<IAntencionPreferencial[]> {
    return this.aadGet(`${this._serviceUrl}/tipos-atencion-preferencial`);
  }

  public async getAllDisabilitiesAsync(): Promise<IDiscapacidad[]> {
    return this.aadGet(`${this._serviceUrl}/discapacidades`);
  }

  public async getAllGendersAsync(): Promise<IGenero[]> {
    return this.aadGet(`${this._serviceUrl}/generos`);
  }

  public async getChildGendersAsync(): Promise<IGenero[]> {
    return this.aadGet(`${this._serviceUrl}/generos-menores-edad`);
  }

  public async getAllEthnicGroupsAsync(): Promise<IGrupoEtnico[]> {
    return this.aadGet(`${this._serviceUrl}/grupos-etnicos`);
  }

  public async getAllPersonTypesAsync(): Promise<ITipoPersona[]> {
    return this.aadGet(`${this._serviceUrl}/tipos-persona`);
  }

  public async getAllEducationLevelsAsync(): Promise<INivelEducativo[]> {
    return this.aadGet(`${this._serviceUrl}/niveles-educativos`);
  }

  public async getAllProfessionsAsync(): Promise<IProfesion[]> {
    return this.aadGet(`${this._serviceUrl}/profesiones`);
  }

  public async getAllApplicantTypeAsync(): Promise<ITipoSolicitante[]> {
    return this.aadGet(`${this._serviceUrl}/tiposSolicitante`);
  }

  public async paginateContactsAsync(request: DataTableRequest): Promise<DataTablesResponse> {
    return this.aadPost(`${this._serviceUrl}/contactos/paginate`, request);
  }

  public async recoverPasswordAsync(data: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/contactos/recover-account`, data);
  }

  public async changePasswordAsync(data: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/contactos/reset-account`, data);
  }

  public async recoverSecretQuestionAsync(data: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/contactos/recover-question`, data);
  }

  public async recoverSecretSecretAnswerAsync(idContacto: string, idPreguntaSecreta: number, respuestaSecreta: string): Promise<boolean> {
    return this.aadGet(`${this._serviceUrl}/contactos/${idContacto}/secret-question/${idPreguntaSecreta}/recover-secret-answer/${respuestaSecreta}`);
  }

  public async verifyLinkRecoverSecretSecretAnswerAsync(idContacto: string): Promise<boolean> {
    return this.aadGet(`${this._serviceUrl}/contactos/${idContacto}/VerifyExpirationRecoverSecretAnswerAsync`);
  }

  public async getAnonymousRequestsAsync(dtRequest: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/paginate-anonymous`, dtRequest);
  }

  public async getMyRequestsAsync(dtRequest: DataTableRequest): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/paginate`, dtRequest);
  }

  public async getMyRequestsByNumberAndCodeAsAnonymousAsync(numeroRadicado: string, codigoConsulta: string): Promise<IRadicadoEntradaExtended> {
    try {
      const result = await this.aadGet(`${this._serviceUrl}/radicado-entrada/getByNumber/${numeroRadicado}/getByCode/${codigoConsulta}/asAnonymous`);
      return result;
    }
    catch (ex) {
      alert('Error al obtener el radicado de entrada anónimo, los datos proporcionados son incorrectos.')
      throw ex;
    }
  }

  private async _aadDownload(url: string, mimeType: string, fileName: string): Promise<void> {
    try {
      const result: Blob = await this.aadBlob(url);

      if (result.size > 0) {
        var file = new Blob([ result ], { type: mimeType });
        let blobUrl = URL.createObjectURL(file);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobUrl);
      } else {
        alert('El radicado seleccionado no tiene documentos adjuntos');
      }
    }
    catch (error) {
      alert('El radicado seleccionado no tiene documentos para descargar');
      console.log(error);
    }
  }

  public async downloadRadicadoEntrada(idRadicadoEntrada: number): Promise<void> {
    await this._aadDownload(`${this._serviceUrl}/radicado-entrada/${idRadicadoEntrada}/download`, 'application/pdf', 'solicitud.pdf');
  }

  public async downloadAnexosRadicadoEntrada(idRadicadoEntrada: number): Promise<void> {
    await this._aadDownload(`${this._serviceUrl}/radicado-entrada/${idRadicadoEntrada}/download-attachments`, 'application/zip', 'anexos.zip');
  }

  public async downloadRadicadoEntradaAsAnonymous(idRadicadoEntrada: number): Promise<void> {
    await this._aadDownload(`${this._serviceUrl}/radicado-entrada/${idRadicadoEntrada}/downloadAsAnonymous`, 'application/pdf', 'solicitud.pdf');
  }

  public async downloadAnexosRadicadoEntradaAsAnonymous(idRadicadoEntrada: number): Promise<void> {
    await this._aadDownload(`${this._serviceUrl}/radicado-entrada/${idRadicadoEntrada}/downloadAttachmentsAsAnonymous`, 'application/zip', 'anexos.zip');
  }

  public async getTramiteMetadataAsync(idTramite: number): Promise<IMetadatoAsociado[]> {
    if (idTramite > 0)
      return this.aadGet(`${this._serviceUrl}/tramites/${idTramite}/metadata`);
  }

  public async getProcesoxFunction(functionId: string): Promise<any> {
    return this.aadGetText(`${this.getProcesoxUrlWithDomain()}/functions/${functionId}`);
  }

  public async getProcesoxRuntimeItemsAsync(entityId: string, select: string[]): Promise<{ [ key: string ]: any }[]> {
    let url = `${this.getProcesoxUrlWithDomain()}/entities/${entityId}/items`;
    if (select !== void 0 && select.length > 0) {
      const items: string[] = [];
      for (let i = 0; i < select.length; i++) {
        items.push(`select=${select[ i ]}`);
      }
      url += '?' + items.join('&');
    }
    return this.aadGet(url);
  }

  public async executeProcesoxFunctionAsync(functionId: string, inputs: { [ key: string ]: any }): Promise<string> {
    let url = `${this.getProcesoxUrlWithDomain()}/functions/${functionId}/run`;
    return this.aadPost(url, inputs || {});
  }

  public async getClasificacionPQRSAsync(tramiteId: number, contactTypeId: number): Promise<IClasificacionPQRS[]> {
    return this.aadGet(`${this._serviceUrl}/tramites/${tramiteId}/getClasificacionPQRSByTipoContacto/${contactTypeId}`);
  }

  public async getDescripcionTramiteAsync(idTramite: number): Promise<string> {
    return this.aadGetText(`${this._serviceUrl}/tramites/${idTramite}/getDescripcionTramiteAsync`);
  }

  public advanceSearchAsync(request: any): Promise<IRadicadoSalida[]> {
    return this.aadPost(`${this._serviceUrl}/radicado-salida/AdvanceSearch`, request);
  }

  //#region Entidades Adscritas

  public async getEntidadAdscritaMyPendingWorksAsync(dtRequest: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/entidad-adscrita/pending-works/paginate`, dtRequest);
  }

  public async getEntidadAdscritaAllPendingWorksAsync(dtRequest: any): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/entidad-adscrita/all-pending-works/paginate`, dtRequest);
  }

  public async exportMyPendingWorksAsync(): Promise<void> {
    await this._aadDownload(`${this._serviceUrl}/entidad-adscrita/pending-works/exportxlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'RespuestasPendientes.xlsx');
  }

  public async SaveAnswerFromEntidadAdscritaAsync(respuesta: IAnswerEntidadAdscrita): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/entidad-adscrita/${respuesta.IdRadicadoEntrada}/SaveAnswerFromEntidadAdscrita`, respuesta);
  }

  public async closeEntidadAdscritaAsync(idRadicados: number[], comments: string): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/entidad-adscrita/CloseEntidadAdscrita`, {
      IdRadicados: idRadicados,
      Observaciones: comments
    });
  }

  public async devolverPqrAsync(idRadicados: number[], comments: string): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/entidad-adscrita/DevolverPqr`, {
      IdRadicados: idRadicados,
      Observaciones: comments
    });
  }

  public async closeEntidadAdscritaBySuperUserAsync(respuesta: ICloserEntidadAdscrita): Promise<string> {
    return this.aadPostGetText(`${this._serviceUrl}/entidad-adscrita/CloseEntidadAdscritaBySuperUser`, respuesta);
  }

  //#endregion


  // Encuesta satisfaccion

  public async getPreguntasEncuestaAsync(): Promise<IPreguntaEncuestaSatisfaccion[]> {
    return this.aadGet(`${this._serviceUrl}/satisfaction-survey/getPreguntasEncuestaAsync`);
  }

  public async getRespuestasByIdPreguntaAsync(idPreguntaEncuesta: number): Promise<IRespuestaEncuestaSatisfaccion[]> {
    return this.aadGet(`${this._serviceUrl}/satisfaction-survey/getRespuestasByIdPreguntaAsync/${idPreguntaEncuesta}`);
  }

  public async sendSurveyResponsesAsync(respuestas: IRespuestaEncuestaSatisfaccion[], idRadicadoEntrada64: string): Promise<boolean> {
    return this.aadPost(`${this._serviceUrl}/satisfaction-survey/${idRadicadoEntrada64}/sendSurveyResponsesAsync`, respuestas);
  }

  public async isSurveyCompletedAsync(idRadicadoEntrada64: string): Promise<boolean> {
    return this.aadGet(`${this._serviceUrl}/satisfaction-survey/${idRadicadoEntrada64}/isSurveyCompletedAsync`);
  }

  // Sede electronica

  public async getPaginatePending(dtRequest: any) {
    let idUsuario = await this.getParameterAsync('Sede_Electronica', 'SuperUsuarioEntidadAdscrita');

    if (idUsuario.Value == sessionStorage.getItem('ioip.pqr-web.session.idcontacto'))
      return this.getEntidadAdscritaAllPendingWorksAsync(dtRequest);
    else
      return this.getEntidadAdscritaMyPendingWorksAsync(dtRequest);
  }

  public async getSignaxServerDocumentById(documentId: string, token: string): Promise<Blob> {
    try {
      addFetch();
      const headers = this.getRequestInit();
      headers.headers[ 'G-Captcha' ] = token;
      const response: Response = await fetch(`${this._serviceUrl}/signed-documents/${documentId}`, headers);
      removeFetch();
      if (response.ok) {
        const result = await response.blob();
        return result;
      }
      else {
        throw response.statusText;
      }
    } catch (ex) {
      removeFetch();
      throw ex;
    }
  }

  public async getDataUserAsync(): Promise<ISignInResponse> {

    try {
      return this.aadGet(`${this._serviceUrl}/b2c`);
    }
    catch (ex) {
      return null;
    }
  }

  public async createDataUserAsync(): Promise<ISignInResponse> {

    try {
      return this.aadPost(`${this._serviceUrl}/b2c/create-user`, null);
    }
    catch (ex) {
      return null;
    }

  }

  public async getParameterAsync(group: string, name: string): Promise<ISuscriptionParameter> {

    try {
      return this.aadGet(`${this._serviceUrl}/parameters/group/${group}/name/${name}`);
    }
    catch (ex) {
      return null;
    }
  }

  //#endregion Chunks

  public async getCurrentDraftAsync(): Promise<IRadicadoEntradaExtended> {
    return this.aadGet(`${this._serviceUrl}/radicado-entrada/current-draft`);
  }

  public async getSessionDraftAsync(sessionId: string): Promise<IRadicadoEntradaExtended> {
    return this.aadGet(`${this._serviceUrl}/radicado-entrada/session/${sessionId}/current-draft`);
  }

  public async saveRadicadoEntradaDraftAsync(radicado: IRadicadoEntradaExtended, reCaptcha: string): Promise<IRespuestaCreacionRadicadoEntrada> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada`, radicado, reCaptcha);
  }

  public async saveAnonymousRadicadoEntradaDraftAsync(sessionId: string, radicado: IRadicadoEntradaExtended, reCaptcha: string): Promise<IRespuestaCreacionRadicadoEntrada> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/session/${sessionId}`, radicado, reCaptcha);
  }

  public async completeDraftAsync(radicado: IRadicadoEntradaExtended, reCaptcha: string): Promise<IRespuestaCreacionRadicadoEntrada> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/complete`, radicado, reCaptcha);
  }

  public async deleteDraftAsync(): Promise<void> {
    return this.aadDelete(`${this._serviceUrl}/radicado-entrada`);
  }

  public async deleteAnonymousDraftAsync(sessionId: string): Promise<void> {
    return this.aadDelete(`${this._serviceUrl}/radicado-entrada/session/${sessionId}`);
  }

  public async completeAnonymousDraftAsync(sessionId: string, radicado: IRadicadoEntradaExtended, reCaptcha: string): Promise<IRespuestaCreacionRadicadoEntrada> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/session/${sessionId}/complete`, radicado, reCaptcha);
  }

  public async createChunkDocumentAsync(request: any): Promise<ICreateChunkResponse> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/documents/start-creation`, request);
  }

  public async createAnonymousChunkDocumentAsync(sessionId: string, request: any): Promise<ICreateChunkResponse> {
    return this.aadPost(`${this._serviceUrl}/radicado-entrada/session/${sessionId}/documents/start-creation`, request);
  }

  public async appendChunkContentAsync(documentId: number, obj: Blob): Promise<ICreateChunkResponse> {
    const formData = new FormData();
    formData.append('content', obj);
    return this.aadPostFormData<ICreateChunkResponse>(`${this._serviceUrl}/radicado-entrada/documents/${documentId}/append`, formData);
  }

  public async appendAnonymousChunkContentAsync(sessionId: string, documentId: number, obj: Blob): Promise<ICreateChunkResponse> {
    const formData = new FormData();
    formData.append('content', obj);
    return this.aadPostFormData<ICreateChunkResponse>(`${this._serviceUrl}/radicado-entrada/session/${sessionId}/documents/${documentId}/append`, formData);
  }

  public async deleteChunkDocumentAsync(documentId: number): Promise<void> {
    return this.aadDelete(`${this._serviceUrl}/radicado-entrada/documents/${documentId}`);
  }

  public async deleteAnonymousChunkDocumentAsync(sessionId: string, documentId: number): Promise<void> {
    return this.aadDelete(`${this._serviceUrl}/radicado-entrada/session/${sessionId}/documents/${documentId}`);
  }

  //#endregion

  public async getLastRequest(): Promise<string> {
    return this.aadGetText(`${this._serviceUrl}/radicado-entrada/validate-last-request`);
  }
}